import React from 'react'

import { Button, IconButton, Input, InputGroup } from 'rsuite'
import Eye from '@rsuite/icons/legacy/Eye'
import EyeSlash from '@rsuite/icons/legacy/EyeSlash'

import Icon from '@mdi/react'
import { mdiAccountTieOutline, mdiKeyChainVariant, mdiLanguageHaskell } from '@mdi/js'

import css from './login.module.scss'

const Login = (props: any) => {
    return (
        <div className={css.main}>
            <div className={css.logo}>
                <Icon path={mdiLanguageHaskell} />
            </div>

            <h1 className={css.title}>АИС ЭИОС</h1>

            <form onKeyPress={props.onKeyPressPassword}>
                <InputGroup inside>
                    <InputGroup.Addon>
                        <Icon path={mdiAccountTieOutline} size={1} style={{ margin: "-2px 0 0 -6px" }} />
                    </InputGroup.Addon>

                    <Input type="text" size="lg" placeholder="Логин оператора" autoComplete="off"
                        value={props.valueLogin} onChange={value => props.setValueLogin(value)}
                    />
                </InputGroup>

                <InputGroup inside>
                    <InputGroup.Addon>
                        <Icon path={mdiKeyChainVariant} size={1} style={{ margin: "-2px 0 0 -6px" }} />
                    </InputGroup.Addon>

                    <Input type={props.isPasswordVisible ? 'text' : 'password'} size="lg" placeholder="Пароль оператора" style={{ paddingRight: "40px" }} autoComplete="off"
                        value={props.valuePassword} onChange={value => props.setValuePassword(value)}
                    />

                    <InputGroup.Addon onClick={() => props.setIsPasswordVisible(!props.isPasswordVisible)} style={{ margin: "-7px -7px 0 0" }}>
                        {props.isPasswordVisible
                            ? <IconButton size="xs" circle appearance="subtle" icon={<EyeSlash style={{ fontSize: "20px" }} />} />
                            : <IconButton size="xs" circle appearance="subtle" icon={<Eye style={{ fontSize: "20px" }} />} />
                        }
                    </InputGroup.Addon>
                </InputGroup>

                <Button size="lg" block color="blue" appearance="primary" onClick={props.onClickButtonInput} loading={props.login.isInputClick}>ВОЙТИ</Button>
            </form>
        </div>
    )
}

export default Login